<template>
  <div class="banner">
    <div class="banner-text">
      <div class="banner-paragraph">{{ title }}</div>
      <h1 class="h4">{{ text }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GildiBanner',
  props: {
    title: { type: String, default: 'Title is missing' },
    text:  { type: String, default: 'Text is missing' }
  }
}
</script>

<style lang="scss" scoped>
@use "@/scss/settings/variables" as var;
@use "@/scss/settings/mixins" as mixins;

.banner {
  /* DO NOT define --banner-bg here (so dark can override upstream) */
  display: flex;
  border-radius: 12px;
  overflow: hidden;
  padding: 2rem;
  min-height: 196px;

  /* Read from the CSS variable with a LIGHT fallback */
  background-color: var(--banner-bg, #194458);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  align-items: center;

  .banner-text {
    color: #fff;

    h1 {
      font-weight: 600;
      font-size: 32px;
      margin-top: 12px;
      @include mixins.text-heading;
    }

    .banner-paragraph {
      font-size: 22px;
      font-weight: 300;
      line-height: 37.4px;
      @include mixins.text-body;
    }
  }
}
</style>
